import { storage } from './Storage.js';
var PAGE_SIZE = 'pageSize';
var itemsPerPageOptions = [20, 50, 100, 200];
var getValidPageSize = function getValidPageSize() {
  var size = parseInt(storage.getItem(PAGE_SIZE));
  if (!size || !itemsPerPageOptions.includes(size)) {
    size = itemsPerPageOptions[0];
    storage.setItem(PAGE_SIZE, size);
  }
  return size;
};
var getPageSize = function getPageSize(size) {
  if (typeof size !== 'undefined') {
    storage.setItem(PAGE_SIZE, size);
    return getValidPageSize();
  } else {
    return getValidPageSize();
  }
};
var pageSize = getPageSize;
export { getPageSize, pageSize };